import React, { Component } from "react";
import { Table, Button, Col, Row } from "antd";
import axios from "axios";
import PrintModal from '../components/PrintModal';
import moment from "moment-timezone"; // VALIDAR DATAS
import numeral from "numeral";
import "./Relatorios.css";

const { Column } = Table;

class FichaFinanceiraPrintModal extends Component {
    state = {
        listaRegistros: [],
        visualizar: false,
        carregando: false,
    }

    componentDidUpdate(propsAnte, stateAnte) {
        if (!stateAnte.visualizar && this.state.visualizar) {
            this.getListaRegistros();
        }
    }

    getListaRegistros = () => {
        this.setState({ carregando: true, listaRegistros: [] });

        const { buscaDataIni, buscaDataFim, buscaNumero, buscaControle, buscaTipo,
            buscaPessoa, buscaPlanoCta, buscaCtaCorrente, buscaTipoDoc, buscaSituacao,
            buscaDescricao } = this.props.filtros;

        if (buscaPessoa) {

            let dataIni = '';
            if ((buscaDataIni) && (buscaDataIni !== undefined)) {
                dataIni = moment(buscaDataIni, 'DD/MM/YYYY').format('YYYY-MM-DD');
            }
            let dataFim = '';
            if ((buscaDataFim) && (buscaDataFim !== undefined)) {
                dataFim = moment(buscaDataFim, 'DD/MM/YYYY').format('YYYY-MM-DD');
            }

            axios
                .get('/titulos/listaFichaFinanc', {
                    params: {
                        print: true,
                        controle: buscaControle,
                        numero: buscaNumero,
                        descricao: buscaDescricao,
                        tipo: buscaTipo.key,
                        situacao: buscaSituacao.key,
                        pessoa: buscaPessoa.key,
                        ctaFin: buscaPlanoCta.key,
                        tipoDoc: buscaTipoDoc.key,
                        ctaCorrente: buscaCtaCorrente.key,
                        dataIni,
                        dataFim,
                    }
                })
                .then(response => {
                    const { data } = response;
                    this.setState({
                        listaRegistros: data,
                        carregando: false,
                    });
                })
                .catch(erro => {
                    console.warn(erro);
                    this.setState({
                        carregando: false,
                    });
                });
        } else {
            this.setState({
                listaRegistros: [],
                carregando: false,
            });
        }

    };

    onCancelar = () => {
        this.setState({
            visualizar: false
        })
    }

    onVisualizar = () => {
        this.setState({
            visualizar: true
        })
    }

    renderValor = (vlr) => {
        return (
            <span> {numeral(parseFloat(vlr)).format('0,000.00')} </span>
        );
    };

    renderParcela = (tparc_parcela, registro) => {
        return (
            <span> {tparc_parcela + ' / ' + registro.qtde_parcelas} </span>
        );
    };

    // renderHistorico = (tit_descricao, registro) => {
    //     return (
    //         <span>{'[' + registro.pes_nome + '] ' + tit_descricao}</span>
    //     );
    // };

    renderData = (data) => {
        if (data) {
            const dataMoment = moment(data);
            return (
                <span>
                    {dataMoment.format('DD/MM/YYYY')}
                </span>
            )
        } else {
            <span></span>
        }
    }



    render() {
        const { listaRegistros, carregando, visualizar } = this.state;
        return (
            <span>
                <Button onClick={this.onVisualizar}>
                    Impressão
                </Button>

                <PrintModal
                    visible={visualizar}
                    onCancel={this.onCancelar}
                >
                    <div >
                        <div className="titulo">
                            Ficha Financeira
                        </div>

                        <Row>
                            <Col xs={22} style={{ marginTop: 10, marginLeft: 40, textAlign: "left" }} >
                                <span style={{ fontWeight: "bold" }}>Cliente/Fornecedor: </span>
                                <span>{this.props.pessoa}</span>
                            </Col>
                        </Row>

                        <Row>
                            <Col xs={22} style={{ marginTop: 10, marginLeft: 20, textAlign: "right" }} >
                                <span style={{ fontWeight: "bold" }}>Recebido: </span>
                                <span>R$ {this.renderValor(this.props.vlrRecebido)}</span>

                                <span style={{ fontWeight: "bold", marginLeft: 50 }}>Pago: </span>
                                <span>R$ {this.renderValor(this.props.vlrPago)}</span>

                                <span style={{ fontWeight: "bold", marginLeft: 50 }}>Resultado: </span>
                                <span>R$ {this.renderValor(this.props.vlrSaldo)}</span>
                            </Col>
                            <Col xs={22} style={{ marginTop: 10, marginLeft: 20, textAlign: "right" }} >
                                <span style={{ fontWeight: "bold" }}>À Receber: </span>
                                <span>R$ {this.renderValor(this.props.vlrReceber)}</span>

                                <span style={{ fontWeight: "bold", marginLeft: 50 }}>À Pagar: </span>
                                <span>R$ {this.renderValor(this.props.vlrPagar)}</span>

                                <span style={{ fontWeight: "bold", marginLeft: 50 }}>Provisão: </span>
                                <span>R$ {this.renderValor(this.props.vlrProvisao)}</span>
                            </Col>
                        </Row>

                        <Row style={{ marginTop: -20 }}>
                            <Table
                                pagination={false}
                                dataSource={listaRegistros}
                                className="tabela"
                                rowKey={(listaRegistros => listaRegistros.tit_idf + '_' + listaRegistros.tparc_parcela)}
                                loading={{
                                    spinning: carregando,
                                    tip: 'Carregando. Aguarde...',
                                    size: "large"
                                }}
                            >
                                <Column
                                    key="tparc_data_parcela"
                                    dataIndex="tparc_data_parcela"
                                    title="Data Venc"
                                    render={this.renderData}
                                    width={90}
                                    align="left"
                                    className="listaCadastro"
                                />
                                <Column
                                    key="pgto_data"
                                    dataIndex="pgto_data"
                                    title="Data Pagto"
                                    render={this.renderData}
                                    width={90}
                                    align="left"
                                    className="listaCadastro"
                                />
                                <Column
                                    key="tparc_parcela"
                                    dataIndex="tparc_parcela"
                                    title="Parcela"
                                    width={60}
                                    align="center"
                                    className="listaCadastro"
                                    render={this.renderParcela}
                                />
                                <Column
                                    key="tit_controle"
                                    dataIndex="tit_controle"
                                    title="Controle"
                                    width={60}
                                    align="left"
                                    className="listaCadastro"
                                />
                                <Column
                                    key="tit_numero"
                                    dataIndex="tit_numero"
                                    title="Número"
                                    width={60}
                                    align="left"
                                    className="listaCadastro"
                                />
                                <Column
                                    key="pc_abreviatura"
                                    dataIndex="pc_abreviatura"
                                    title="Conta"
                                    width={60}
                                    align="left"
                                    className="listaCadastro"
                                />
                                <Column
                                    key="tparc_valor"
                                    dataIndex="tparc_valor"
                                    title="Vlr Parcela"
                                    render={this.renderValor}
                                    width={70}
                                    align="right"
                                    className="listaCadastro"
                                />
                                <Column
                                    key="pgto_vlr_pago"
                                    dataIndex="pgto_vlr_pago"
                                    title="Vlr Pago"
                                    render={this.renderValor}
                                    width={70}
                                    align="right"
                                    className="listaCadastro"
                                />
                                <Column
                                    key="pgto_vlr_restante"
                                    dataIndex="pgto_vlr_restante"
                                    title="Vlr Rest"
                                    render={this.renderValor}
                                    width={70}
                                    align="right"
                                    className="listaCadastro"
                                />
                                <Column
                                    key="tit_descricao"
                                    dataIndex="tit_descricao"
                                    title="Descrição"
                                    width={150}
                                    align="left"
                                    className="listaCadastro"
                                    // render={this.renderHistorico}
                                />
                            </Table>
                        </Row>
                    </div>

                </PrintModal>
            </span>
        );
    }
}

export default FichaFinanceiraPrintModal;



// WEBPACK FOOTER //
// ./src/relatorios/FichaFinanceiraPrintModal.js